import type React from 'react';

interface ErrorMessageProps {
    message: string | React.ReactNode;
    className?: string;
}

const AdminErrorMessage: React.FC<ErrorMessageProps> = ({ 
    message,
    className = "bg-soft-white mx-auto flex flex-col items-center justify-center min-h-screen w-full relative overflow-hidden",
}) => { 
    return (
        <div className={className}>
            {/* Decorative background circles */}
            <div className="absolute top-[-200px] left-[-200px] w-[500px] h-[500px] rounded-full bg-pistachio opacity-30 blur-xl animate-[float_15s_ease-in-out_2s_infinite]"></div>
            <div className="absolute top-[-80px] right-[-200px] w-[500px] h-[500px] rounded-full bg-moss-green opacity-30 blur-xl animate-[floatX_12s_ease-in-out_0.5s_infinite]"></div>
            <div className="absolute top-[-200px] right-[200px] w-[300px] h-[300px] rounded-full bg-moss-green opacity-70 blur-xl animate-[diagonal_16s_ease-in-out_1s_infinite]"></div>
            <div className="absolute bottom-[-300px] right-5 w-[500px] h-[500px] rounded-full bg-pistachio opacity-50 blur-xl animate-[float_11s_ease-in-out_2.5s_infinite_reverse]"></div>
            <div className="absolute bottom-[160px] right-[450px] w-[100px] h-[100px] rounded-full bg-moss-green opacity-70 blur-xl animate-[circular_25s_linear_infinite]"></div>
            <div className="absolute bottom-[-80px] left-[-200px] w-[600px] h-[600px] rounded-full bg-moss-green opacity-60 blur-xl animate-[float_20s_ease-in-out_infinite]"></div>
            <div className="absolute bottom-50 left-40 w-[200px] h-[200px] rounded-full bg-pistachio opacity-50 blur-xl animate-[floatX_9s_ease-in-out_0.7s_infinite]"></div>
            <div className="absolute top-[100px] left-[40%] w-[180px] h-[180px] rounded-full bg-moss-green opacity-40 blur-lg animate-[floatX_9s_ease-in-out_0.7s_infinite]"></div>
            <div className="absolute bottom-[20%] right-[30%] w-[180px] h-[180px] rounded-full bg-pistachio opacity-40 blur-lg animate-[floatX_9s_ease-in-out_0.7s_infinite]"></div>
            <div className="absolute top-[40%] right-[10%] w-[150px] h-[150px] rounded-full bg-moss-green opacity-30 blur-lg animate-[float_11s_ease-in-out_2.5s_infinite_reverse]"></div>


            {/* Main Content */}
            <div className="z-10 relative">
                <img 
                    src="/assets/icons/undraw/questions-moss-green.svg" 
                    alt="Error illustration" 
                    className="w-[500px] h-[500px] mb-4" 
                />
                <div className="max-w-md text-moss-green text-3xl text-center mx-auto font-sans">
                    {message}
                </div>
            </div>
        </div>
    );
};

export default AdminErrorMessage;
